/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { reportingControllerGetChatUsage } from "./reportingControllerGetChatUsage";
import { reportingControllerGetProjectUsage } from "./reportingControllerGetProjectUsage";
import { reportingControllerGetRedlineUsage } from "./reportingControllerGetRedlineUsage";
import { reportingControllerGetReviewUsage } from "./reportingControllerGetReviewUsage";
import { reportingControllerGetSkillUsage } from "./reportingControllerGetSkillUsage";

export function reportingService() {
  return { reportingControllerGetProjectUsage, reportingControllerGetRedlineUsage, reportingControllerGetSkillUsage, reportingControllerGetReviewUsage, reportingControllerGetChatUsage }
}